<template>
  <div id='results'>
    <div 
      v-for="(question, index) in questions" 
      v-bind:key='question.rowid' 
      class='question' 
      v-bind:style="{'background-color': question.color }">
      <div id='questionText'>{{ question.text }}</div>
      <div class='answer' id='yes'>{{ question.yes }} × Ja &nbsp;{{ percentages[index].yes }}</div>
      <div class='answer' id='no'>{{ question.no }} × Nein &nbsp;{{ percentages[index].no  }}</div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Results',
  props: ['type'],
  data(){
    return {
      questions: []
    }
  },
  computed: {
    percentages(){
      return this.questions.map(q => {
        return {
          yes: ((q.yes * 100 / (q.yes + q.no)) || 0.00).toFixed(2) + '%',
          no: ((q.no * 100 / (q.yes + q.no)) || 0.00).toFixed(2) + '%'
        }
      })
    }
  },
  methods: {
    async getMyQuestions(){
      let hash = localStorage.getItem('hash')
      let response = await fetch(`${process.env.VUE_APP_API}/${this.type}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          hash
        })
      })
      let data = await response.json()
      this.questions = data
    }
  },
  mounted(){
    this.getMyQuestions()
  }
}
</script>
<style scoped>
#results{
  height: 90%;
}
.question{
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr 100px;
  grid-template-areas:  
  "question question"
  "yes no";
  min-height: 100%;
  color: white;
  margin-bottom: 5px;
}


#questionText{
  padding: 20px;
  text-align: center;
  justify-self: center;
  align-self: center;
  grid-area: question;
  font-size: 1.5em;
}

.answer{
  text-align: center;
  line-height: 100px;
  font-size: 1.1em;
  color: #2d3436;
  font-weight: bold;
}

#yes{
  grid-area: yes;
}

#no{
  grid-area: no;
}

#questionText{
  padding: 20px;
  text-align: center;
  justify-self: center;
  align-self: center;
  grid-area: question;
  font-size: 1.5em;
}
</style>
